var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08665 5.17246C1.76121 5.4979 1.23358 5.4979 0.90814 5.17246C0.582703 4.84703 0.582703 4.31939 0.90814 3.99395L3.65222 1.24987C4.30309 0.598999 5.35837 0.599001 6.00924 1.24987L8.75332 3.99395C9.07876 4.31939 9.07876 4.84703 8.75332 5.17246C8.42788 5.4979 7.90024 5.4979 7.57481 5.17246L5.66406 3.26172V13.3332C5.66406 13.7934 5.29097 14.1665 4.83073 14.1665C4.37049 14.1665 3.9974 13.7934 3.9974 13.3332V3.26172L2.08665 5.17246Z",
    fill: "#1A1D1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.42699e6b3c257ee2f6eb3f353cd7a092.svg";
export { ForwardRef as ReactComponent };